import { Component, inject, OnInit } from '@angular/core';
import { AnimationBuilder, AnimationController } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { Router } from '@angular/router';

// Environment
import { environment } from '../environments/environment';

// Services
import { CommonService } from './core/services/common/common.service';
import { LoggerService } from './core/services/logger/logger.service';
import { TranslationService } from './core/services/translation/translation.service';
import { OrientationService } from './core/services/orientation/orientation.service';
import { StorageService } from './core/services/storage/storage.service';

// Animation
import { slideInAnimation } from './shared/animations/animation';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [],
  animations: slideInAnimation,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly animationCtrl = inject(AnimationController);
  public readonly common = inject(CommonService);
  private readonly logger = inject(LoggerService);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslationService);
  private readonly orientation = inject(OrientationService);
  public readonly storage = inject(StorageService);

  constructor() {
    this.translate.setLanguage();
    this.common.getUniqueDeviceID();

    this.logger.consoleLog('AppComponent', 'constructor', environment.ENV);

    SplashScreen.hide({ fadeOutDuration: 500 })
      .then(() => {
        this.common.getPlatform();
        void this.router.navigateByUrl('/splash');
      })
      .catch((error) => this.logger.consoleLog('AppComponent', 'constructor', error));
  }

  animation: AnimationBuilder = (baseEl: Element) =>
    this.animationCtrl.create().addElement(baseEl).duration(180).fromTo('opacity', 1, 0);

  ngOnInit(): void {
    this.setupSafeAreas();
    this.lock('portrait-primary');
  }

  private lock(orientation: OrientationType): void {
    // We can call setOrientation directly since pressing a button is a user interaction
    void this.orientation.setOrientation(orientation);
    this.orientation.lock(orientation);
  }

  private setupSafeAreas(): void {
    const docStyle = document.documentElement.style;
    const ionSafeAreaBottom = docStyle.getPropertyValue('--ion-safe-area-bottom');
    if (ionSafeAreaBottom === '') {
      document.documentElement.style.setProperty('--safe-area-top', '16px');
      document.documentElement.style.setProperty('--safe-area-bottom', '16px');
    }
  }
}
